"use strict";

exports.__esModule = true;
exports.Loader = exports.LoaderContainer = exports.WebView = exports.Icon = exports.LauncherContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  border: 0.5rem solid #f3f3f3;\n  border-radius: 50%;\n  border-top: 0.5rem solid #3498db;\n  width: 7rem;\n  height: 7rem;\n  -webkit-animation: spin 2s linear infinite; /* Safari */\n  animation: spin 2s linear infinite;\n\n  /* Safari */\n  @-webkit-keyframes spin {\n    0% {\n      -webkit-transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(360deg);\n    }\n  }\n\n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  width: ", ";\n  height: ", ";\n  background-color: ", ";\n  mask: url(", ");\n  mask-repeat: no-repeat;\n  mask-position: center;\n  mask-size: contain;\n  @media (max-width: 767px) {\n    transform: translate(-0.1rem, -0.5rem);\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: contents;\n  @media (max-width: 767px) {\n    display: none;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  @media (min-width: 767px) {\n    background-color: transparent;\n    ", ";\n\n    div {\n      float: right;\n    }\n  }\n\n  @media (max-width: 767px) {\n    ", ";\n    div {\n      button {\n        border-radius: 10rem;\n        width: 4rem;\n        height: 4rem;\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}
/**
 * Zendesk Launcher button styles
 * @param {boolean} isPositionOverlap if web view and this is true, launcher will overlap to the component below it
 */


var LauncherContainer = _styledComponents["default"].div(_templateObject(), function (_ref) {
  var isPositionOverlap = _ref.isPositionOverlap;
  return isPositionOverlap ? "\n      height: 2.5rem;\n      padding-right: 2rem;\n      position: absolute;\n      top: -2.25rem;\n      right: 0;\n    " : "\n      padding: 1rem 2rem;\n      position: relative;\n    ";
}, function (_ref2) {
  var isPositionOverlap = _ref2.isPositionOverlap;
  return isPositionOverlap ? "\n      position: absolute;\n      top: -2.2rem;\n      right: 0;  \n      padding-right: 2rem;" : "";
});

exports.LauncherContainer = LauncherContainer;

var WebView = _styledComponents["default"].div(_templateObject2());

exports.WebView = WebView;

var Icon = _styledComponents["default"].div(_templateObject3(), function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.color;
}, function (props) {
  return props.icon;
});

exports.Icon = Icon;

var LoaderContainer = _styledComponents["default"].div(_templateObject4());

exports.LoaderContainer = LoaderContainer;

var Loader = _styledComponents["default"].div(_templateObject5());

exports.Loader = Loader;